import { useState } from "react";
import { Link } from "react-router-dom";
import { authService } from "../services/authService";
import logo from "../assets/images/logo.png";
import platformImg from "../assets/images/oil-platform.png";
import "../styles/auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Email validation regex pattern - only @ongc.co.in domain
  const emailRegex = /^[a-zA-Z0-9.]+@ongc\.co\.in$/;

  const validateEmail = (email) => {
    if (!email) {
      setEmailError("Please enter your email address");
      return false;
    }

    if (!emailRegex.test(email)) {
      setEmailError(
        "Please enter a valid ONGC email address (must end with @ongc.co.in)"
      );
      return false;
    }

    setEmailError("");
    return true;
  };

  const handleEmailChange = (e) => {
    setError("");
    const value = e.target.value.replace(/[^a-zA-Z0-9@.]/g, "");
    setEmail(value);
    if (value) validateEmail(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Failed to process request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Success screen component
  const SuccessScreen = () => (
    <div className="text-center">
      <div className="alert alert-success" role="alert">
        <h6 className="mb-2">Email Verification Sent</h6>
        <p className="mb-0">
          A password reset link has been sent to <strong>{email}</strong>
        </p>
        <p className="mt-2 mb-0">
          Please check your inbox and follow the instructions to reset your
          password.
        </p>
      </div>
      <Link to="/login" className="btn login-btn mt-3">
        BACK TO LOGIN
      </Link>
    </div>
  );

  return (
    <div className="container-fluid login-container">
      <div className="row h-100">
        <div
          className="col-md-8 p-0 platform-image"
          style={{ backgroundImage: `url(${platformImg})` }}
        ></div>

        <div className="col-md-4 login-form-container">
          <div className="ongc-logo">
            <img src={logo} alt="ONGC Logo" className="img-fluid" />
          </div>

          <div className="login-text">
            <h5>Forgot Password</h5>
          </div>

          <div className="form-container">
            {success ? (
              <SuccessScreen />
            ) : (
              <>
                
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className={`form-control ${
                        emailError ? "is-invalid" : ""
                      }`}
                      id="email"
                      placeholder="user@ongc.co.in"
                      value={email}
                      onChange={handleEmailChange}
                      onBlur={() => validateEmail(email)}
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
{" "}
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                  <button
                    type="submit"
                    className="btn login-btn mt-3 w-100"
                    disabled={loading}
                  >
                    {loading ? "PROCESSING..." : "RESET PASSWORD"}
                  </button>

                  <div className="text-center mt-3">
                    <Link to="/login">Back to Login</Link>
                  </div>
                </form>
              </>
            )}
          </div>

          <div className="copyright">
            Copyright © 2025 ONGC. All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
